import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';


const Pagination = ({ pageNumber, totalPages, onChangePage, totalRecords, searchPageNumber }) => {

  const [pageNumbers, setPageNumbers] = useState([]);

  console.log(totalRecords, searchPageNumber);
  // Navigate to the previous page
  const handlePrev = () => {
    if (pageNumber > 1) {
      onChangePage(pageNumber - 1);
    }
  };

  // Navigate to the next page
  const handleNext = () => {
    if (pageNumber < totalPages) {
      onChangePage(pageNumber + 1);
    }
  };


  useEffect(() => {
    pageChange();
  }, [pageNumber]);


  let startPage, endPage;

  const pageChange = () => {
    
    if (totalPages <= 9) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 9 total pages so calculate start and end pages
      if (pageNumber >= 6) {

        startPage = pageNumber - 4; // Remove the first page
        endPage = pageNumber + 4; // Add one page at the end
        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = totalPages - 8;
        }
      } else {
        startPage = 1;
        endPage = 9;
      }
    }
    // Generate page numbers
    let pageArr = [];
    for (let i = startPage; i <= endPage; i++) {
      pageArr.push(i);

    }
    setPageNumbers(pageArr);


  }


  return (
    <div>
      {pageNumber !== 1 && (
        <span className='paginationarrow' onClick={handlePrev} disabled={pageNumber <= 1}>
          &lt;
        </span>
      )}
      {pageNumbers.map(number => (
        <button className='paginationBtn'
          key={number}
          style={{ margin: '0 4px', backgroundColor: pageNumber == number ? "green" : "white", color: pageNumber == number ? "white" : "green" }}
          disabled={pageNumber === number}
          onClick={() => onChangePage(number)}
        >
          {number}
        </button>
      ))}
      {pageNumber !== totalPages && (
        <span className='paginationarrow' onClick={handleNext} disabled={pageNumber >= totalPages}>
          &gt;
        </span>
      )}
    </div>
  );
};

Pagination.propTypes = {
  pageNumber: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  totalRecords: PropTypes.number,
  searchPageNumber: PropTypes.number.isRequired,
};

export default Pagination;